export default "/images/logo.png?ff5deef0f41bf7f24b2da344243e8d28";